import { render, staticRenderFns } from "./invoiceDetailCompany.vue?vue&type=template&id=063c11f0"
import script from "./invoiceDetailCompany.vue?vue&type=script&lang=js"
export * from "./invoiceDetailCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports